import type { MediaItem, MessageDto } from '../api/types';

/** Копируем только настоящий текст, включая подпись, без описаний вложений. */
export function copyableMessageText(message: MessageDto | undefined): string {
  const text = message?.payload.data?.text ?? '';
  return message?.type !== 99 && text.trim() ? text : '';
}

export function messageDownloadItems(message: MessageDto | undefined, fileId?: string) {
  const all = (message?.payload.data?.media ?? []).filter((item) => !!item.fileId);
  const current: MediaItem | undefined = all.find((item) => item.fileId === fileId) ?? all[0];
  return { all, current };
}
